import adminTools from './admin.tools';
import adminProperties from './admin.properties';
import adminSchema from './admin.schems';
import adminMessages from './admin.messages';
import adminGetters from './admin.getters';
import adminActions from './admin.actions';
import { Inventory } from '../buruburu/inventory';
import { ReplicantModuleState } from '../utils';
import { Immutable } from '@play-co/replicant';

export type Admin = typeof Admin;
// eslint-disable-next-line no-redeclare
export namespace Admin {
  export const $DEPENDENCIES = { Inventory };

  export const schema = adminSchema;
  export const tools = adminTools;
  export const properties = adminProperties;
  export const messages = adminMessages(Admin, $DEPENDENCIES);
  export const getters = adminGetters;
  export const actions = adminActions(Admin, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Admin>;
  export type State = Immutable<MutableState>;
}
